import { AgencySettings_VehicleTypesEnum } from 'src/api/gen'
import { GranularityEnum } from 'src/commons/types'

export const ORDERED_GRANULARITIES = [
  GranularityEnum.quarter,
  GranularityEnum.month,
  GranularityEnum.week,
  GranularityEnum.day,
  GranularityEnum.hour,
]

export const ORDERED_DEVICE_CATEGORIES = [
  AgencySettings_VehicleTypesEnum.bicycle,
  AgencySettings_VehicleTypesEnum.car,
  AgencySettings_VehicleTypesEnum.delivery_bot,
  AgencySettings_VehicleTypesEnum.moped,
  AgencySettings_VehicleTypesEnum.scooter,
  AgencySettings_VehicleTypesEnum.cargo_bicycle,
  AgencySettings_VehicleTypesEnum.other,
] as AgencySettings_VehicleTypesEnum[]
